import { getSafeLocation } from '../utils/safeLocation';

const useIsBackOffice = () => getSafeLocation().pathname.includes('admin');

export default useIsBackOffice;
